import { LocalDate } from '../time/LocalDate';
export function ssnValidationMessage(ssn) {
    if (!ssn) {
        return 'Fødselsnummeret kan ikke være tomt';
    }
    if (ssn.length !== 11) {
        return 'Fødselsnummeret må ha 11 tegn';
    }
    if (!ssn.match(/^[0-9]*$/)) {
        return 'Fødselsnummeret må kun bestå av tall';
    }
    var _sum = function (str, factors) {
        var sum = 0;
        for (var i = 0, l = factors.length; i < l; ++i) {
            sum += parseInt(str.charAt(i), 10) * factors[i];
        }
        return sum;
    };
    var checksum1 = 11 - (_sum(ssn, [3, 7, 6, 1, 8, 9, 4, 5, 2]) % 11);
    if (checksum1 === 11) {
        checksum1 = 0;
    }
    var checksum2 = 11 - (_sum(ssn, [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]) % 11);
    if (checksum2 === 11) {
        checksum2 = 0;
    }
    if (checksum1 !== parseInt(ssn.charAt(9)) || checksum2 !== parseInt(ssn.charAt(10))) {
        return 'Nummeret er ikke et gyldig fødselsnummer';
    }
    var dob = getDateOfBirthFromSsn(ssn);
    if (dob.month < 1 || dob.month > 12 || dob.day < 1 || dob.day > 31 || dob.year < 1854 || dob.year > 2039) {
        return 'Fødselsnummeret representerer en ugyldig fødselsdato';
    }
    if (ssnIsDnumber(ssn) && ssnIsHnumber(ssn)) {
        return 'Fødselsnummeret indikerer både H-nummer og D-nummer, men kan ikke være begge';
    }
    return undefined;
}
export function isValidSsn(ssn) {
    return !ssnValidationMessage(ssn);
}
function getCentury(fnr) {
    var individualNumber = parseInt(fnr.substring(6, 9));
    var birthYear = parseInt(fnr.substring(4, 6));
    var century = 0;
    if (individualNumber <= 499) {
        century = 1900;
    }
    else if (individualNumber >= 500 && birthYear < 40) {
        century = 2000;
    }
    else if (individualNumber >= 500 && individualNumber <= 749 && birthYear >= 54) {
        century = 1800;
    }
    else if (individualNumber >= 900 && birthYear > 39) {
        century = 1900;
    }
    return century;
}
/**
 * @internal Only exported to also be used in commons
 */
export function getDateOfBirthFromSsn(ssn) {
    var day = parseInt(ssn.substring(0, 2));
    // To support D-numbers: https://no.wikipedia.org/wiki/Fødselsnummer#D-nummer
    if (day > 40) {
        day = day - 40;
    }
    var month = parseInt(ssn.substring(2, 4));
    // To support H-numbers: https://no.wikipedia.org/wiki/Fødselsnummer#H-nummer
    if (month > 40) {
        month = month - 40;
    }
    var year = parseInt(ssn.substring(4, 6)) + getCentury(ssn);
    return new LocalDate(year, month, day);
}
/**
 * @internal Only exported to also be used in commons
 */
export function ssnIsDnumber(ssn) {
    return parseInt(ssn.substring(0, 2)) > 40;
}
/**
 * @internal Only exported to also be used in commons
 */
export function ssnIsHnumber(ssn) {
    return parseInt(ssn.substring(2, 4)) > 40;
}
